import React, { memo } from 'react';
import { Grid, Link } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import { useRegisterFormFooterStyles } from './RegisterFormFooter.styles';

export const RegisterFormFooter = memo(() => {
    const classes = useRegisterFormFooterStyles();
    const { t } = useTranslation();
    const loginUrl = `${process.env.REACT_APP_LOGIN_BASE_URL}${t('auth.register_form_footer.login_link')}`;

    return (
        <Grid data-signa="auth-register-form-footer-container" className={classes.container} container>
            <Grid>
                <Trans
                    i18nKey={'auth.register_form_footer.do_you_have_and_account'}
                    components={[<Link href={loginUrl} />]}
                ></Trans>
            </Grid>
        </Grid>
    );
});
